<script>
import CabecalhoRelatorio from '../CabecalhoRelatorio.vue';
import transparenciaServico from '../../../servico';

export default {
    components: { CabecalhoRelatorio },
    data() {
      return {
        informacaoInstitucional: null,
        arquivos: [],
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      detalhesDaInformacaoInstitucional(id) {
        return transparenciaServico
          .detalhesInformacaoInstitucional(id)
          .then(informacaoInstitucional => {
            this.informacaoInstitucional = informacaoInstitucional
          });
      },
      nomeArquivo(arquivo) {
        return arquivo.slice(arquivo.lastIndexOf('\\') + 1);
      },
      carregarArquivos(id) {
        transparenciaServico
          .arquivosInstitucional(id)
          .then(arquivos => {
            this.arquivos = arquivos;
          });
      },
      download(arquivo) {
        transparenciaServico
          .downloadInstitucional(this.$route.params.id, this.nomeArquivo(arquivo))
          .then(arquivo => {
            arquivo.download();
          });
      },
      voltar() {
        this.$router.push({
          name: 'transparencia.institucional',
          query: this.$route.query
        });
      },
    },
    computed: {
    },
    async mounted() {
      if (!this.configuracao.acessarInstitucionalPortalTransparencia) {
        this.$router.push({
          name: 'transparencia.projetos',
          query: this.$route.query
        });
      }
      await this.detalhesDaInformacaoInstitucional(this.$route.params.id);
      await this.carregarArquivos(this.$route.params.id);
    },
    watch: {
    }
}
</script>

<template>
  <div v-if="informacaoInstitucional">
    <div class="ibox float-e-margins">
      <div class="ibox-title hidden-print">
        <div class="row">
          <div class="col-md-10 flex-container " style="justify-content:start; padding-left:15px">
            <h3><b>Institucional - {{ informacaoInstitucional.titulo  }}</b></h3>
          </div>

          <div class="col-md-2 flex-container" style="justify-content:end; gap:10px">

            <button class="btn btn-primary" @click="voltar">
              <i class="fa fa-file-pdf-o"></i> Voltar
            </button>

          </div>
        </div>

        <div class="row">
          <dl class="col-xs-12">
            <dt>Descrição</dt>
            <dd class="white-space-pre">{{ informacaoInstitucional.descricao || '---' }}</dd>
          </dl>
        </div>

        <div>
          <div style="border-top: 1px solid #ccc; padding-bottom: 12px;" />
          <div class="row" style="padding-bottom: 6px;">
            <h3 class="col-xs-12"><b>Anexos</b></h3>
          </div>

          <div class="row" style="padding-bottom: 6px;">
            <div class="col-xs-12">
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Documento</th>
                      <th>Visualizar/Download</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="arquivo in arquivos">
                      <td>{{ nomeArquivo(arquivo) }}</td>
                      <td class="action">
                        <button type="button"
                                class="btn btn-default btn-xs"
                                @click="download(arquivo)">
                          <i class="fa fa-download"></i>
                        </button>
                      </td>
                    </tr>
                    <tr v-if="arquivos.length === 0">
                      <td colspan="2" class="text-center">Nenhum arquivo encontrado.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/transparencia/componentes/compartilhado/institucional/InstitucionalDetalhes.vue